import { Job } from './model';

/**
 * canceled                                                         SKIPPED
 *                                                                     ^
 * success                                                             ^       TAG_REMINDER -> FINISH
 *                                                                     ^              ^
 * main       PENDING_VALIDATION -> ENQUEUED -> UPLOAD_INPROGRESS -> BIND_INPROGRESS ---^
 *                     v                            v                  v
 * failure         INVALID_FILE_NAME          UPLOAD_FAILURE       BIND_FAILURE
 */
export enum JobStatus {
  // initial status
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  // file name is invalid - not allow to restart job
  INVALID_FILE_NAME = 'INVALID_FILE_NAME',
  // Job is created and awaiting upload
  ENQUEUED = 'ENQUEUED',
  // job has begun processing and is now uploading
  UPLOAD_INPROGRESS = 'UPLOAD_INPROGRESS',
  // upload has failed
  UPLOAD_FAILURE = 'UPLOAD_FAILURE',
  /**
   * @deprecated Not set by the main upload flow anymore. Since MYUA-16384 the
   * file node is created by the backend on the last multipart part (no separate
   * bind step). Kept because the value is still read by UI/progress code.
   */
  BIND_INPROGRESS = 'BIND_INPROGRESS',
  /**
   * @deprecated Not set by the main upload flow anymore (no separate bind step).
   * Kept because the value is still read by UI/progress code and jobRestarted.
   */
  BIND_FAILURE = 'BIND_FAILURE',
  // bind succeeded, no further action is required
  FINISH = 'FINISH',
  SKIPPED = 'SKIPPED',
  TAG_REMINDER = 'TAG_REMINDER',
}

const failedStatuses = [
  JobStatus.BIND_FAILURE,
  JobStatus.UPLOAD_FAILURE,
  JobStatus.INVALID_FILE_NAME,
];
const successStatuses = [JobStatus.FINISH, JobStatus.TAG_REMINDER, JobStatus.SKIPPED];
const settledStatuses = [...failedStatuses, ...successStatuses];

export function jobIsSettled(job: Job) {
  return settledStatuses.includes(job.status);
}

// job is successful, but not necessarily can be deleted from job list
export function jobIsSuccessful(job: Job) {
  return successStatuses.includes(job.status);
}
// job has finished and can be disposed of
export function jobIsDisposable(job: Job) {
  return job.status === JobStatus.FINISH;
}
export function jobIsTagReminder(job: Job) {
  return job.status === JobStatus.TAG_REMINDER;
}
export function jobIsFailed(job: Job) {
  return failedStatuses.includes(job.status);
}
export function jobIsSkipped(job: Job) {
  return job.status === JobStatus.SKIPPED;
}
